
const apiConfig = {
    GENERATE_LOGIN_OTP: {
        url: '/auth/agency/verify',
        method: 'POST'
    },
    LOGIN: {
        url: '/auth/agency/login',
        method: 'POST'
    },

    GENERATE_REGISTRATION_OTP: {
        url: '/auth/validate',
        method: 'POST'
    },

    REGISTER: {
        url: '/auth/agency/register',
        method: 'POST'
    },

    FETCH_USER_PROFILE: {
        url: '/user/profile',
        method: 'GET'
    },
    UPDATE_USER_PROFILE: {
        url: 'a/<agencyId>/profile',
        method: 'GET'
    },

    FETCH_BRANDS: {
        url: '/a/<agencyId>/brand',
        method: 'GET',
        staleTime: 1*60*1000
    },
    FETCH_BRAND: {
        url: '/a/<agencyId>/brand/<brandId>/edit',
        method: 'GET',
        staleTime: 0
    },
    CREATE_BRAND: {
        url: '/a/<agencyId>/brand',
        method: 'POST',
    },
    UPDATE_BRAND: {
        url: '/a/<agencyId>/brand/<brandId>',
        method: 'PUT',
    },

    FETCH_USERS: {
        url: '/a/<agencyId>/user',
        method: 'GET',
        staleTime: 1*60*1000
    },
    FETCH_USER: {
        url: '/a/<agencyId>/user/<userId>/edit',
        method: 'GET',
        staleTime: 0
    },
    CREATE_USER: {
        url: '/a/<agencyId>/user',
        method: 'POST',
    },
    UPDATE_USER: {
        url: '/a/<agencyId>/user/<userId>',
        method: 'PUT',
    },
    DELETE_USER: {
        url: '/a/<agencyId>/user/<userId>',
        method: 'DELETE',
    },
    FETCH_USER_BRANDS: {
        url: '/a/<agencyId>/brand/list',
        method: 'GET',
        staleTime: 1*60*1000
    },
    FETCH_ROLES: {
        url: '/a/role',
        method: 'GET',
        staleTime: 10*60*1000
    },

    CREATE_CAMPAIGN: {
        url: '/a/<agencyId>/campaign',
        method: 'POST'
    },

    FETCH_CAMPAIGNS: {
        url: '/a/<agencyId>/campaign',
        method: 'GET',
        staleTime: 1*60*1000
    },

    FETCH_CAMPAIGN: {
        url: '/a/<agencyId>/campaign/<campaignId>',
        method: 'GET',
        staleTime: 0
    },

    FETCH_CAMPAIGN_DETAILS: {
        url: '/a/<agencyId>/campaign/<campaignId>/edit',
        method: 'GET',
        staleTime: 0
    },
    UPDATE_CAMPAIGN_DETAILS: {
        url: '/a/<agencyId>/campaign/<campaignId>',
        method: 'PUT',
    },
    FETCH_CAMPAIGN_REQUIREMENT: {
        url: '/a/<agencyId>/campaign/<campaignId>/requirement',
        method: 'GET',
        staleTime: 0
    },

    FETCH_CITIES: {
        url: 'a/city/list',
        method: 'GET'
    },
    FETCH_TOPICS: {
        url: 'a/topic/list',
        method: 'GET'
    },

    FETCH_REGIONS: {
        url: 'a/region/list',
        method: 'GET',
        staleTime: 10*60*1000
    },

    FETCH_CAMPAIGN_CREATIVES: {
        url: '/a/<agencyId>/campaign/<campaignId>/creative',
        method: "GET",
        staleTime: 0
    },
    UPDATE_CAMPAIGN_CREATIVES: {
        url: '/a/<agencyId>/campaign/<campaignId>/creative',
        method: "POST"
    },
    FETCH_CAMPAIGN_GALLERY: {
        url: '/a/<agencyId>/campaign/<campaignId>/file',
        method: "GET",
        staleTime: 0
    },
    ADD_CAMPAIGN_GALLERY_IMAGE: {
        url: '/a/<agencyId>/campaign/<campaignId>/file',
        method: "POST",
    },
    DELETE_CAMPAIGN_GALLERY_IMAGE: {
        url: '/a/<agencyId>/campaign/<campaignId>/file/<fileId>',
        method: "DELETE",
    },

    FETCH_CAMPAIGN_APPLICATIONS: {
        url: '/a/<agencyId>/campaign/<campaignId>/application',
        method: 'GET',
        staleTime: 1*60*1000
    },
    FETCH_APPLICATION: {
        url: '/a/<agencyId>/campaign/<campaignId>/application/<influencerId>',
        method: 'GET',
        staleTime: 1*60*1000
    },
    FETCH_APPLICATION_POSTS: {
        url: '/a/<agencyId>/campaign/<campaignId>/application/<influencerId>/post',
        method: 'GET',
        staleTime: 1*60*1000
    },
    PROCESS_APPLICATION: {
        url: '/a/<agencyId>/campaign/<campaignId>/application/<influencerId>',
        method: 'PUT',
    },
    FETCH_INFLUENCER_INSIGHTS: {
        url: 'a/<agencyId>/influencer/<influencerId>/insights',
        method: 'GET',
        staleTime: 1*60*1000
    },
    FETCH_INFLUENCER_POST: {
        url: 'a/<agencyId>/influencer/<influencerId>/post/<postId>',
        method: 'GET',
        staleTime: 1*60*1000
    },
    FETCH_CAMPAIGN_COLLABORATIONS: {
        url: '/a/<agencyId>/campaign/<campaignId>/collaboration',
        method: 'GET',
        staleTime: 1*60*1000
    },
    FETCH_CAMPAIGN_COLLABORATION: {
        url: '/a/<agencyId>/campaign/<campaignId>/collaboration/<collaborationId>',
        method: 'GET',
        staleTime: 1*60*1000
    },
    FETCH_CAMPAIGN_COLLABORATION_BASIC: {
        url: '/a/<agencyId>/campaign/<campaignId>/collaboration/<collaborationId>/basic',
        method: 'GET',
        staleTime: 1*60*1000
    },
    FETCH_INFLUENCER_MEDIA: {
        url: 'a/<agencyId>/influencer/<influencerId>/post',
        method: 'GET',
        staleTime: 1*60*1000
    },
    FETCH_SOCIAL_POSTS: {
        url: 'a/<agencyId>/social-account/<socialAccountId>/post',
        method: 'GET',
        staleTime: 1*60*1000
    },
    FETCH_SOCIAL_ACCOUNT: {
        url: 'a/<agencyId>/social-account/<socialAccountId>',
        method: 'GET',
        staleTime: 1*60*1000
    },
    FETCH_SOCIAL_POST: {
        url: 'a/<agencyId>/social-account/<socialAccountId>/post/<socialPostId>',
        method: 'GET',
        staleTime: 1*60*1000
    },

    FETCH_CAMPAIGN_PAYMENTS: {
        url: 'a/<agencyId>/campaign/<campaignId>/payment',
        method: 'GET',
        staleTime: 1*60*1000
    },
    FETCH_CAMPAIGN_INSIGHTS: {
        url: 'a/<agencyId>/campaign/<campaignId>/insights',
        method: 'GET',
        staleTime: 5*60*1000
    },
    FETCH_CAMPAIGN_PERFORMANCE: {
        url: 'a/<agencyId>/campaign/<campaignId>/performance',
        method: 'GET',
        staleTime: 5*60*1000
    },
    PROCESS_COLLABORATION: {
        url: '/a/<agencyId>/campaign/<campaignId>/collaboration/<influencerId>',
        method: 'PUT',
    },
    REQUEST_CAMPAIGN_APPROVAL: {
        url: '/a/<agencyId>/campaign/<campaignId>/approval',
        method: 'POST',
    },
    MARK_CAMPAIGN_COMPLETED: {
        url: '/a/<agencyId>/campaign/<campaignId>/complete',
        method: 'POST',
    },
    FETCH_CAMPAIGNS_COUNT: {
        url: '/a/<agencyId>/campaign/totals',
        method: 'GET',
        staleTime: 1*60*1000
    },
    BOOKMARK_APPLICATION: {
        url: '/a/<agencyId>/campaign/<campaignId>/application/<influencerId>/bookmark',
        method: 'POST',
    },
    FETCH_COLLABORATION_MILESTONE: {
        url: '/a/<agencyId>/campaign/<campaignId>/collaboration/<influencerId>/milestone/<milestoneId>',
        method: "GET",
        staleTime: 1*60*1000
    },
     SUBMIT_STEP_DEADLINE: {
        method: "POST",
        url: "/a/<agencyId>/campaign/<campaignId>/collaboration/<influencerId>/step/<stepSlug>/deadline"
    },
    ACKNOWLEDGE_STEP: {
        method: "POST",
        url: "/a/<agencyId>/campaign/<campaignId>/collaboration/<influencerId>/step/<stepSlug>/acknowledge"
    },
    FETCH_ALL_COLLABORATIONS: {
        url: '/a/<agencyId>/collaboration',
        method: "GET",
        staleTime: 1*60*1000
    },
    FETCH_ADDRESS: {
        url: 'a/address/<addressUUID>',
        method: "GET",
        staleTime: 10*60*1000
    },
    CREATE_ADDRESS: {
        url: 'a/<agencyId>/address',
        method: "POST",
    },
    FETCH_COLLABORATION_PERMALINK_FILE: {
        method: "POST",
        url: "a/<agencyId>/campaign/<campaignId>/collaboration/<influencerId>/permalink-file",
        staleTime: 10*60*1000
    },
    PROCESS_COLLABORATION_MILESTONE_STEP: {
        method: 'POST',
        url: "a/<agencyId>/campaign/<campaignId>/collaboration/<influencerId>/step"
    },
    FETCH_BASIC_POST: {
        method: 'url',
        url: '/a/post/<postId>',
        staleTime: 10*60*1000
    },
    FETCH_BASIC_SOCIAL_POST: {
        method: 'url',
        url: '/a/social-post/<postId>',
        staleTime: 10*60*1000
    },
    FETCH_CAMPAIGN_MILESTONES: {
        method: 'GET',
        url: '/a/<agencyId>/campaign/<campaignId>/milestone',
        staleTime: 5*60*1000
    },
    UPDATE_CAMPAIGN_MILESTONES: {
        method: 'POST',
        url: '/a/<agencyId>/campaign/<campaignId>/milestone',
    },
    UPDATE_CAMPAIGN_MILESTONE: {
        method: 'PUT',
        url: '/a/<agencyId>/campaign/<campaignId>/milestone/<milestoneId>',
    },
    CREATE_CAMPAIGN_MILESTONE: {
        method: 'POST',
        url: '/a/<agencyId>/campaign/<campaignId>/milestone',
    },
    FETCH_CAMPAIGN_GIGS: {
            method: 'GET',
            url: '/a/<agencyId>/campaign/<campaignId>/gig',
            staleTime: 5*60*1000
    },
    UPDATE_CAMPAIGN_GIG: {
        method: 'PUT',
        url: '/a/<agencyId>/campaign/<campaignId>/gig/<gigId>',
    },
    CREATE_CAMPAIGN_GIG: {
        method: 'POST',
        url: '/a/<agencyId>/campaign/<campaignId>/gig',
    },
    UPDATE_MILESTONE_GIGS: {
        method: 'POST',
        url: '/a/<agencyId>/campaign/<campaignId>/milestone/<milestoneId>/gigs'
    },
    UPDATE_MILESTONE_CTAS: {
        method: 'POST',
        url: '/a/<agencyId>/campaign/<campaignId>/milestone/<milestoneId>/cta'
    },
    FETCH_COLLABS_SUMMARY: {
        url: '/a/<agencyId>/collaboration/task/summary',
        method: 'GET',
        staleTime: 1*60*1000
    },
    FETCH_CAMPAIGN_ACTIVITY: {
        url: '/a/<agencyId>/campaign/activity',
        method: 'GET',
        staleTime: 1*60*1000
    },
    SEARCH_CAMPAIGNS: {
        url: '/a/<agencyId>/campaign/list',
        method: 'GET'
    },
    FETCH_ELIGIBLE_GIG_STEP_BP: {
        url: '/a/gig-step/list'
    },
    FETCH_COLLABS_DATA_BP: {
        url: '/a/<agencyId>/campaign/<campaignId>/collaboration/milestone/<milestoneId>/step/<gigStep>'
    },
    COPY_CAMPAIGN : {
        url: '/a/<agencyId>/campaign/<campaignId>/copy',
        method:'POST'
    },
    UPLOAD_IG_PERMALINK_TO_CAMPAIGN:{
        url: 'a/<agencyId>/campaign/<campaignId>/ig-permalink-upload',
        method: 'POST'
    },
    FETCH_CAMPAIGN_IG_PERMALINKS: {
        url: 'a/<agencyId>/campaign/<campaignId>/ig-permalink-upload',
        method: 'GET',
        staleTime: 1*60*1000
    },
    FETCH_CONTENT_LIBRARY: {
        url: 'a/<agencyId>/content',
        method: 'GET',
        staleTime: 1*60*1000
    },
    CREATE_FIREBASE_TOKEN: {
        url: '/a/<agencyId>/firebase-token',
        method: 'POST',
        staleTime: 50*60*1000
    },
    COLLAB_CHAT_ROOM: {
        url: '/a/<agencyId>/campaign/<campaignId>/collaboration/<influencerId>/chat-room',
        method: 'POST'
    },
    FETCH_CHATS_LIST: {
        url: '/user/chat',
        method: 'GET',
        staleTime: 1*60*1000
    },
    FETCH_CAMPAIGN_CREATE_DATA: {
        url: '/a/<agencyId>/campaign/create',
        method: 'GET',
        staleTime: 5*60*1000
    },
    FETCH_CAMPAIGN_SCREENING_QUESTIONS: {
        url: '/a/<agencyId>/campaign/<campaignId>/screening-question',
        method: 'GET',
        staleTime: 5*60*1000
    },
    CREATE_CAMPAIGN_SCREENING_QUESTION: {
        url: '/a/<agencyId>/campaign/<campaignId>/screening-question',
        method: 'POST',
    },
    UPDATE_CAMPAIGN_SCREENING_QUESTION: {
        url: '/a/<agencyId>/campaign/<campaignId>/screening-question/<questionId>',
        method: 'PUT',
    },
    DELETE_CAMPAIGN_SCREENING_QUESTION: {
        url: '/a/<agencyId>/campaign/<campaignId>/screening-question/<questionId>',
        method: 'DELETE',
    },
    FETCH_WALLET: {
        url: '/a/<agencyId>/wallet',
        method: 'GET',
        staleTime: 1*60*1000
    },
    VALIDATE_GST_NUMBER: {
        url: '/a/<agencyId>/gstin/validate',
        method: 'POST',
    },
    ADD_GST_NUMBER_TO_WALLET: {
        url: '/a/<agencyId>/gstin',
        method: 'POST',
    },
    CREATE_VBA_ACCOUNT: {
        url: '/a/<agencyId>/vba',
        method: 'POST',
    },
    FETCH_APPLICATION_COST: {
        url: '/a/<agencyId>/campaign/<campaignId>/application/<applicationId>/cost',
        method: 'GET',
        staleTime: 1*60*1000
    },
    INIT_IG_CONNECTION: {
        url: '/a/<agencyId>/c/ig',
        method: 'GET',
    },
    SUBMIT_ACCESS_TOKEN_FOR_IG_CONNECT: {
        url: '/a/<agencyId>/c/ig/init',
        method: "POST"
    },
    LIST_CONNECTED_IG_ACCOUNTS : {
        url: '/a/<agencyId>/c/ig/l',
        method: 'GET'
    },
    LINK_IG_ACCOUNT: {
        url: '/a/<agencyId>/c/ig/l/<accountId>',
        method: 'POST'
    },
    FETCH_SOCIAL_ACCOUNTS: {
        url: '/a/<agencyId>/social-account',
        method: 'GET',
        staleTime: 10*60*1000
    },
    ADD_SOCIAL_ACCOUNT: {
        url: '/a/<agencyId>/social-account',
        method: 'POST',
    },
    FETCH_SOCIAL_POST_COMMENTS: {
        url: '/a/<agencyId>/social-account/<socialAccountId>/post/<socialPostId>/comment',
        method: 'GET'
    },
    DELETE_SOCIAL_POST_COMMENTS: {
        url: '/a/<agencyId>/social-account/<socialAccountId>/post/<socialPostId>/comment/<commentId>',
        method: 'DELETE'
    },
    REPLY_SOCIAL_POST_COMMENT: {
        url: '/a/<agencyId>/social-account/<socialAccountId>/post/<socialPostId>/comment/<commentId>/reply',
        method: 'POST'
    },
    REPLY_PRIVATELY_SOCIAL_POST_COMMENT: {
        url: '/a/<agencyId>/social-account/<socialAccountId>/post/<socialPostId>/comment/<commentId>/reply/private',
        method: 'POST'
    },
    SEARCH_CREATORS: {
        url: '/a/<agencyId>/creator-marketplace/search',
        method: "POST"
    },
    FETCH_SOCIAL_ACCOUNT_TRACKED_POSTS: {
        url: '/a/<agencyId>/tracked-post',
        method: 'GET',
        staleTime: 10*60*1000
    },
    ATTACH_TRACKED_POST_TO_CAMPAIGN: {
        url: '/a/<agencyId>/tracked-post/<trackedPostId>/attach',
        method: 'POST'
    },
    CREATE_OFFLINE_CAMPAIGN: {
        url: '/a/<agencyId>/campaign/offline',
        method: 'POST'
    },
    FETCH_CAMPAIGN_CONTENT: {
        url: '/a/<agencyId>/campaign/<campaignId>/post',
        staleTime: 10*60*1000,
        method: "GET"
    },
    ADD_COLLABORATION_PAYMENT: {
        url: '/a/<agencyId>/campaign/<campaignId>/collaboration/<collaborationId>/payment',
        method: 'POST'
    },
    ENABLE_MEDIA_TRACKING: {
        url: 'a/<agencyId>/track-media/<socialAccountId>/enable',
        method: 'POST'
    },
    REFRESH_TRACKED_MEDIA: {
        url: 'a/<agencyId>/track-media/<socialAccountId>/refresh',
        method: 'POST'
    },
    FETCH_SOCIAL_ACCOUNT_CREATORS: {
        url: '/a/<agencyId>/track-media/<socialAccountId>/creator',
        method: 'GET',
        staleTime: 10*60*1000
    },
    FETCH_SOCIAL_ACCOUNT_CONTENT: {
        url: '/a/<agencyId>/track-media/<socialAccountId>/post',
        method: 'GET',
        staleTime: 10*60*1000
    },
    FETCH_COMPETITION_GROUPS: {
        url: '/a/<agencyId>/competition-group',
        method: 'GET',
        staleTime: 10*60*1000
    },
    CREATE_COMPETITION_GROUPS: {
        url: '/a/<agencyId>/competition-group',
        method: 'POST',
    },
    UPDATE_COMPETITION_GROUPS: {
        url: '/a/<agencyId>/competition-group/<competitionGroupId>',
        method: 'PUT',
    },
    ADD_COMPETITOR: {
        url: '/a/<agencyId>/competition',
        method: 'POST',
    },
    FETCH_COMPETITION_GROUP: {
        url: '/a/<agencyId>/competition-group/<competitionGroupId>',
        method: 'GET',
        staleTime: 10*60*1000
    },
    FETCH_COMPETITION_GROUP_CREATORS_OVERLAPPING_DATA: {
        url: '/a/<agencyId>/competition-group/<competitionGroupId>/social-account/<socialAccountId>/overlap',
        method: 'GET',
        staleTime: 10*60*1000
    },
    FETCH_COMPETITORS: {
        url: '/a/<agencyId>/competition',
        method: 'GET',
        staleTime: 10*60*1000
    },
    FETCH_COMPETITION_REPORT_SHARE_ID: {
        url: '/a/<agencyId>/competition-group/<competitionGroupId>/share',
        method: 'POST',
        staleTime: 6*60*60*1000 // 6Hours
    },
    FETCH_SHARED_COMPETITION_GROUP: {
        url: '/share/competition-group/<competitionGroupShareId>',
        method: 'GET',
        staleTime: 10*60*1000
    },
    FETCH_DASHBOARD_FEATURES: {
        url: '/a/<agencyId>/dashboard/features',
        method: 'GET',
        staleTime: 10*60*1000
    },
    FETCH_COMPETITION_CONTENT: {
        url: '/a/<agencyId>/competition/post',
        method: 'GET',
        staleTime: 10*60*1000
    },
    UPDATE_ACCOUNT_TYPE: {
        url: '/a/<agencyId>/agency/type',
        method: 'POST'
    },
    UPDATE_ACCOUNT_WEBSITE : {
        url: '/a/<agencyId>/agency/website',
        method: 'POST'
    },
    SKIP_ONBOARDING_STEP : {
        url: '/a/<agencyId>/onboarding/<step>/skip',
        method: 'POST'
    }
}

export default apiConfig